<template>
    <div class="container eventWrapper" ref="eventWrapper">
        <slot></slot>
    </div>
</template>

<script>
    import Cookies from 'js-cookie'

    export default {
        name: "MainEventBanner",
        created() {
            let vm = this
            this.$nextTick(function () {
                const bannerHide = Cookies.get('bannerHide')
                console.log(document.cookie)
                if (bannerHide) {
                    $(vm.$refs.eventWrapper).hide();
                }

                $(vm.$refs.eventWrapper).find('.event-close').click(function () {
                    Cookies.set('bannerHide', '1', {expires: 1})

                    $(vm.$refs.eventWrapper).hide();
                });
            })
        }
    }
</script>

<style scoped>

</style>